import React from "react";
import {
  Box,
  Col,
  Dialog,
  Divider,
  FabButton,
  Flex,
  Gap,
  Icon,
  InputField,
  Row,
  SelectField,
  Typography,
} from "../../../../ppui";
import { OrganizationBx, OrganizationEmDetails } from "../../../style";
import {
  TbCake,
  TbChartPie,
  TbCirclePercentage,
  TbFolder,
  TbHome,
  TbPencil,
  TbPhone,
  TbUser,
  TbUsers,
} from "react-icons/tb";

const Nominee = () => {
  const [NomineeEdit, setNominee] = React.useState(false);
  const NomineeModalOpen = () => setNominee(true);
  const NomineeModalClose = () => setNominee(false);
  return (
    <>
      <Flex justifyContent="space-between" gap={"10"}>
        <Typography variant="h5" mb={"0"}>
          Nominee
        </Typography>
        <FabButton
          size="sm"
          icon={<TbPencil />}
          onClick={NomineeModalOpen}
          variant="filled"
          shape="box"
        />
      </Flex>
      <Gap height={30} />
      <OrganizationEmDetails>
        <OrganizationBx>
          <Icon size={"lg"}>
            <TbUser />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Nominee Name
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              Amit Das
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbUsers />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Relationship with Nominee
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              Brother
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbCake />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Date of Birth
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              08/01/1998
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbPhone />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Nominee Contact Number
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              8134738446
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbHome />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Nominee Address
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              1234 Elm Street, Apt 5B. Salt Lake, Kolkata.
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbChartPie />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Percentage of Benefit
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              90%
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbFolder />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              ID Proof Attachment
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              Demo-document.pdf
            </Typography>
          </Box>
        </OrganizationBx>
      </OrganizationEmDetails>

      <Divider gap={20} />

      <Flex justifyContent="space-between" gap={"10"}>
        <Typography variant="h5" mb={"0"}>
          Nominee Two
        </Typography>
        <FabButton
          size="sm"
          icon={<TbPencil />}
          onClick={NomineeModalOpen}
          variant="filled"
          shape="box"
        />
      </Flex>
      <Gap height={30} />
      <OrganizationEmDetails>
        <OrganizationBx>
          <Icon size={"lg"}>
            <TbUser />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Nominee Name
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              Sayantan Dey
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbUsers />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Relationship with Nominee
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              Brother
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbCake />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Date of Birth
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              08/01/1998
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbPhone />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Nominee Contact Number
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              8134738446
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbHome />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Nominee Address
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              1234 Elm Street, Apt 5B. Salt Lake, Kolkata.
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbChartPie />
          </Icon>
          <Box>
            <Typography variant="body2" mb={"0"}>
              Percentage of Benefit
            </Typography>
            <Typography variant="body1" mb={"0"} color="primary">
              90%
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
  <Icon size={"lg"}>
    <TbFolder />
  </Icon>
  <Box>
    <Typography variant="body2" mb={"0"}>
      ID Proof Attachment
    </Typography>
    <Typography variant="body1" mb={"0"} color="primary">
      Demo-document.pdf
    </Typography>
  </Box>
</OrganizationBx>

      </OrganizationEmDetails>

      <Dialog
        title="Nominee"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        open={NomineeEdit}
        onClose={NomineeModalClose}
        separator
      >
        <Row rowGap={20}>
          <Col sm={12} md={6}>
            <InputField
              required
              fullWidth
              label="Nominee Name"
              type="text"
              placeholder="Type Here"
              valueSinc={true}
            />
          </Col>

          <Col sm={12} md={6}>
            <SelectField
              fullWidth
              required
              label="Relationship with Nominee"
              options={[
                { id: "option1", name: "Brother" },
                { id: "option2", name: "Spouse" },
                { id: "option3", name: "Child" },
                { id: "option4", name: "Parent" },
              ]}
              defaultValue="fixed"
              placeholder="Select Here..."
            />
          </Col>

          <Col sm={12} md={6}>
            <InputField
              required
              fullWidth
              label="Nominee Contact Number"
              type="number"
              placeholder="Type Here"
            />
          </Col>

          <Col sm={12} md={6}>
            <InputField
              required
              fullWidth
              label="Nominee Address"
              type="text"
              placeholder="Type Here"
            />
          </Col>

          <Col sm={12} md={6}>
            <InputField
              required
              fullWidth
              label="Percentage of Benefit"
              type="number"
              placeholder="Type Here"
              prefix={<TbCirclePercentage />}
            />
          </Col>

          <Col sm={12} md={6}>
            <InputField
              required
              fullWidth
              label="ID Proof Attachment"
              type="file"
              placeholder="Type Here"
              valueSinc={true}
            />
          </Col>
        </Row>
      </Dialog>
    </>
  );
};

export default Nominee;
